export const DEBIT = 'debit';
export const CREDIT = 'credit';
export const CASH = 'cash';
export const IN_APP_PAYMENT = 'inAppPayment';



// WEBPACK FOOTER //
// ../utils/constants/payments.js